/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { FC } from "react";
import { ACTION_BUTTON_SIZE, ACTION_BUTTON_STYLE } from "./ActionButton";
import { CommandButton, ICommandButtonProps } from "./Button/CommandButton";

export interface IActionCommandButtonProps extends ICommandButtonProps {
	style?: ACTION_BUTTON_STYLE;
	size?: ACTION_BUTTON_SIZE;
}

export const ActionCommandButton: FC<IActionCommandButtonProps> = ({ children, ...props }) => {
	const baseClass = BEM("edt-action-button-" + props.size, null, {
		style: props.style,
		size: props.size
	});

	return (
		<CommandButton {...props} baseClass={baseClass}>
			{children}
		</CommandButton>
	);
};

ActionCommandButton.defaultProps = {
	style: ACTION_BUTTON_STYLE.DEFAULT,
	size: ACTION_BUTTON_SIZE.DEFAULT
};
